export default {
  init() {
    // JavaScript to be fired on all pages
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired

    // Change modal content when opening modal
    $('#modal').on('show.bs.modal', function (e) {
      var button = $(e.relatedTarget);
      var title = button.data('title') ? button.data('title') : '';
      var content = JSON.parse(button.data('content'));
      var modal = $(this);
      modal
        .find('.modal-header')
        .prepend('<h5 class="modal-title" id="modalLabel">' + title + '</h5>');
      modal.find('.modal-body').html(content);
    });

    // Remove modal content after its hidden
    $('#modal').on('hidden.bs.modal', function () {
      var modal = $(this);
      modal.find('.modal-title').remove();
      modal.find('.modal-body').html('');
    });

    $(document).ready(function () {
      $('.select').on('click', function (e) {
        e.preventDefault();
        const button = $(this);
        const formContainer = button.closest('form, .form-container');
        const selectField = formContainer.find('select').length
          ? formContainer.find('select')
          : $('select');
        if (selectField.length) {
          selectField.val(button.data('value')).trigger('change');
        }
        const target = $(button.attr('href'));
        if (target.length) {
          $('html, body').animate({ scrollTop: target.offset().top }, 500);
        }
      });
    });
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js